import React, { useState, useEffect } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import SelectColaborador from './SelectColaborador';

const MENU = [
  { path: '/agenda',        label: '📅 Agenda' },
  { path: '/clientes',      label: '👥 Clientes' },
  { path: '/crm',           label: '📋 CRM' },
  { path: '/sdr',           label: '📞 SDR' },
  { path: '/saudadora',     label: '🤖 Saudadora', apenasVagner: true },
  { path: '/closer',        label: '🧭 Closer', consultores: true },
  { path: '/demandas',      label: '⚖️ Demandas Processuais' },
  { path: '/sucesso-cliente', label: '💚 Sucesso do Cliente', consultores: true },
  { path: '/financeiro',    label: '💵 Financeiro', apenasVagner: true },
  { path: '/oportunidades', label: '🎯 Oportunidades' },
  { path: '/relatorios',    label: '📊 Relatórios' },
  { path: '/gerador',       label: '📁 Gerador de Arquivos' },
  { path: '/utilitarios',   label: '🧰 Utilitários' },
  {
    grupo: 'INPI', icone: '🏛️', submenu: [
      { path: '/inpi',           label: '🏛️ Central INPI' },
      { path: '/dashboard-revista', label: '📊 Dashboard da Revista' },
      { path: '/pesquisa-marca', label: '🔍 Pesquisa de Marca' },
      { path: '/oposicao',       label: '⚖️ Oposição' },
      { path: '/consultar-rpi',  label: '📰 Consultar RPI' },
    ]
  },
  { path: '/parceiros',     label: '🤝 Parceiros', consultores: true },
  { path: '/comunicacao',   label: '💬 Comunicação WA', apenasVagner: true },
  { path: '/automacoes',    label: '⚙️ Automações' },
  { path: '/assistente',    label: '✨ Clau IA', apenasVagner: true },
  { path: '/sugestoes',     label: '💬 Respostas IA', apenasVagner: true },
  { path: '/agente-vendas', label: '🤖 Agente de Vendas', apenasVagner: true },
  { path: '/prospeccao',    label: '🎯 Prospecção Auto', apenasVagner: true },
  { path: '/pap',           label: '🚶 PAP Porta a Porta', apenasVagner: true },
];

// ⭐ Acesso rápido (menu que abre no hover, ao lado da lua): as 8 telas mais
// usadas de verdade — medidas no log de acesso (21/08/2026) — em ordem
// alfabética, pra achar sempre no mesmo lugar
const ATALHOS_RAPIDOS = [
  { path: '/agenda',         icone: '📅', rotulo: 'Agenda' },
  { path: '/clientes',       icone: '👥', rotulo: 'Clientes' },
  { path: '/comunicacao',    icone: '💬', rotulo: 'Comunicação WA', apenasVagner: true },
  { path: '/crm',            icone: '📋', rotulo: 'CRM' },
  { path: '/demandas',       icone: '⚖️', rotulo: 'Demandas Processuais' },
  { path: '/financeiro',     icone: '💵', rotulo: 'Financeiro', apenasVagner: true },
  { path: '/pesquisa-marca', icone: '🔍', rotulo: 'Pesquisa de Marca' },
  { path: '/sdr',            icone: '📞', rotulo: 'SDR' },
];

function getEmailDoToken() {
  try {
    const token = localStorage.getItem('token');
    if (!token) return '';
    // JWT usa base64url: normaliza antes do atob (senão '-'/'_' quebram a decodificação)
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return payload.email || '';
  } catch { return ''; }
}

function token() { return localStorage.getItem('token'); }

function statusTarefa(t) {
  if (t.realizado) return { label: 'Feito', cor: '#16a34a', bg: '#f0fdf4' };
  if (!t.data_agendada) return { cor: '#9ca3af', bg: '#f9fafb' };
  const dStr = t.data_agendada.slice(0, 10);
  const hojeLocal = new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString().slice(0, 10);
  if (dStr < hojeLocal) return { label: 'Atrasada', cor: '#dc2626', bg: '#fef2f2' };
  return { label: 'Pendente', cor: '#d97706', bg: '#fffbeb' };
}

function fmtHora(iso) {
  if (!iso || !iso.includes('T')) return '';
  const brt = new Date(new Date(iso).getTime() - 3 * 60 * 60 * 1000);
  return brt.toISOString().split('T')[1].slice(0, 5);
}

const ATALHOS = [
  { tecla: 'Alt + A', acao: 'Ir para Agenda' },
  { tecla: 'Alt + O', acao: 'Ir para Oportunidades' },
  { tecla: 'Alt + R', acao: 'Ir para CRM' },
  { tecla: 'Alt + H', acao: 'Ir para Home' },
  { tecla: 'Alt + D', acao: 'Alternar tema claro/escuro' },
  { tecla: '?', acao: 'Mostrar atalhos de teclado' },
  { tecla: 'ESC', acao: 'Fechar modais' },
];

// Esc fecha qualquer modal aberto no app (o de cima, se houver mais de um):
// acha o overlay fixo que cobre a tela e aciona o × / Fechar / Cancelar dele.
// Vale pra todos os modais, atuais e futuros, sem precisar ligar um a um.
function fecharModalDeCima() {
  const overlays = [...document.querySelectorAll('div[style*="fixed"]')].filter(el => {
    const s = window.getComputedStyle(el);
    if (s.position !== 'fixed' || s.display === 'none' || s.visibility === 'hidden') return false;
    const r = el.getBoundingClientRect();
    return r.width >= window.innerWidth * 0.9 && r.height >= window.innerHeight * 0.9;
  });
  if (!overlays.length) return;
  // O modal "de cima" é o que contém o elemento visível no centro da tela;
  // se não der pra saber, fica o de maior z-index (empate: o mais recente)
  const centro = document.elementFromPoint(Math.floor(window.innerWidth / 2), Math.floor(window.innerHeight / 2));
  let topo = (centro && overlays.filter(o => o.contains(centro)).pop()) || null;
  if (!topo) topo = overlays.reduce((a, b) => ((parseInt(window.getComputedStyle(b).zIndex) || 0) >= (parseInt(window.getComputedStyle(a).zIndex) || 0) ? b : a));
  const botoes = [...topo.querySelectorAll('button')];
  const alvo = botoes.find(b => ['×', '✕'].includes(b.textContent.trim()))
    || botoes.find(b => /^(fechar|cancelar)$/i.test(b.textContent.trim()));
  if (alvo) alvo.click();
  else topo.click(); // modais que fecham clicando no fundo escuro
}

export default function Layout({ nomeUsuario, cargoUsuario, onLogout }) {
  const emailUsuario = getEmailDoToken();
  const isVagner = emailUsuario === 'vagnerfreittas@gmail.com';

  const [agora, setAgora] = useState(new Date());
  const [menuAberto, setMenuAberto] = useState(false);
  const [gruposAbertos, setGruposAbertos] = useState([]);
  const [modalCal, setModalCal] = useState(false);
  // Calendário global: visão mensal, semanal ou diária
  const [visaoCal, setVisaoCal] = useState('mes'); // 'mes' | 'semana' | 'dia'
  const [diaCal, setDiaCal] = useState(null); // âncora ISO das visões semana/dia
  // Botão flutuante de ações rápidas (presente em todas as páginas)
  const [fabAberto, setFabAberto] = useState(false);
  // 👁️ Conferir tela: null = fechado, '' = escolhendo, '/rota' = página no modal
  const [espiarRota, setEspiarRota] = useState(null);
  const [modalTarefaRapida, setModalTarefaRapida] = useState(false);
  const [modalNovaVenda, setModalNovaVenda] = useState(false);
  const [tarefas, setTarefas] = useState([]);
  const [mesCal, setMesCal] = useState(() => { const h = new Date(); return { ano: h.getFullYear(), mes: h.getMonth() }; });
  const [diaExp, setDiaExp] = useState(null);
  const [telefonesCache, setTelefonesCache] = useState({});
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('darkMode') === '1');
  // Menu de acesso rápido: abre no hover; o timer segura 250ms na saída pra
  // não fechar quando o mouse cruza o vão entre o botão e o menu
  const [menuRapido, setMenuRapido] = useState(false);
  const timerAtalho = React.useRef(null);
  const [modalAtalhos, setModalAtalhos] = useState(false);

  async function buscarTelefone(clienteId) {
    if (!clienteId || telefonesCache[clienteId] !== undefined) return;
    try {
      const r = await fetch(`/clientes/${clienteId}`, { headers: { Authorization: `Bearer ${token()}` } });
      const c = await r.json();
      setTelefonesCache(prev => ({ ...prev, [clienteId]: c.telefone || '' }));
    } catch { setTelefonesCache(prev => ({ ...prev, [clienteId]: '' })); }
  }

  async function buscarTelefoneOp(opId) {
    const key = `op_${opId}`;
    if (!opId || telefonesCache[key] !== undefined) return;
    try {
      const r = await fetch(`/oportunidades/${opId}`, { headers: { Authorization: `Bearer ${token()}` } });
      const op = await r.json();
      setTelefonesCache(prev => ({ ...prev, [key]: op.telefone || '' }));
    } catch { setTelefonesCache(prev => ({ ...prev, [`op_${opId}`]: '' })); }
  }

  function copiarTelefone(tel) {
    const num = tel.replace(/\D/g, '');
    if (navigator.clipboard) {
      navigator.clipboard.writeText(num).catch(() => { const el = document.createElement('textarea'); el.value = num; document.body.appendChild(el); el.select(); document.execCommand('copy'); document.body.removeChild(el); });
    } else { const el = document.createElement('textarea'); el.value = num; document.body.appendChild(el); el.select(); document.execCommand('copy'); document.body.removeChild(el); }
  }
  const location = useLocation();
  const navigate = useNavigate();

  function abrirCal() {
    setModalCal(true);
    // Tarefas da Agenda + ⚖️ demandas processuais (prazos do INPI) juntas
    Promise.all([
      fetch('/agenda', { headers: { Authorization: `Bearer ${token()}` } }).then(r => r.json()).catch(() => []),
      fetch('/demandas', { headers: { Authorization: `Bearer ${token()}` } }).then(r => r.json()).catch(() => []),
    ]).then(([tarefas, demandas]) => {
      const prazos = (Array.isArray(demandas) ? demandas : []).map(d => ({
        _id: 'demanda_' + d._id,
        descricao: `⚖️ ${d.tipo} — ${d.cliente_nome}${d.marca ? ` (${d.marca})` : ''}`,
        data_agendada: d.prazo,
        cliente_id: d.cliente_id,
        cliente_nome: d.cliente_nome,
        destinado_a: 'Vagner Freitas',
        realizado: d.status === 'cumprida' ? (d.resultado || 'Cumprida') : '',
      }));
      setTarefas([...(Array.isArray(tarefas) ? tarefas : []), ...prazos]);
    }).catch(() => {});
  }

  function toggleGrupo(nome) {
    setGruposAbertos(prev => prev.includes(nome) ? prev.filter(g => g !== nome) : [...prev, nome]);
  }

  useEffect(() => {
    const t = setInterval(() => setAgora(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => { setMenuAberto(false); }, [location]);

  useEffect(() => {
    if (darkMode) document.body.classList.add('dark-mode');
    else document.body.classList.remove('dark-mode');
    localStorage.setItem('darkMode', darkMode ? '1' : '0');
  }, [darkMode]);

  useEffect(() => {
    function handleKey(e) {
      const tag = document.activeElement?.tagName;
      const emInput = tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || document.activeElement?.isContentEditable;
      if (e.key === 'Escape') {
        setModalCal(false); setDiaExp(null); setModalAtalhos(false); setFabAberto(false);
        fecharModalDeCima(); // fecha também o modal da página que estiver aberta
        return;
      }
      if (e.altKey) {
        const mapa = { KeyA: '/agenda', KeyO: '/oportunidades', KeyR: '/crm', KeyH: '/painel' };
        if (mapa[e.code]) { e.preventDefault(); navigate(mapa[e.code]); return; }
        if (e.code === 'KeyD') { e.preventDefault(); setDarkMode(d => !d); return; }
      }
      if (e.key === '?' && !emInput) { setModalAtalhos(m => !m); }
    }
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [navigate]);

  const hora = agora.toLocaleTimeString('pt-BR');
  const data = agora.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: '#d0d3d8' }}>
      <header style={{
        background: '#0a1628', color: '#fff', padding: '0 16px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 56,
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)', position: 'sticky', top: 0, zIndex: 200,
      }}>
        <Link to="/painel" style={{ color: '#fff', textDecoration: 'none', fontWeight: 700, fontSize: 17 }}>
          Preserva Marcas&#174;
        </Link>

        {/* Data/hora — some em telas muito pequenas */}
        <div style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: 8, alignItems: 'center' }}
          className="header-datetime">
          <span style={{ fontSize: 14, fontWeight: 700, letterSpacing: '0.04em' }}>{hora}</span>
          <span style={{ fontSize: 14, fontWeight: 700 }}>{data}</span>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          {/* ⭐ Acesso rápido: passa o mouse e o menu abre (sem clicar).
              As telas do dia a dia, na ordem de uso real do sistema. */}
          <div style={{ position: 'relative' }}
            onMouseEnter={() => { clearTimeout(timerAtalho.current); setMenuRapido(true); }}
            onMouseLeave={() => { timerAtalho.current = setTimeout(() => setMenuRapido(false), 250); }}>
            <button onClick={() => setMenuRapido(m => !m)} title="Acesso rápido às telas que você mais usa"
              style={{ background: menuRapido ? 'rgba(255,255,255,0.16)' : 'none', border: 'none', color: '#fff', fontSize: 18, cursor: 'pointer', lineHeight: 1, padding: '4px 6px', borderRadius: 6 }}>
              ⭐
            </button>
            {menuRapido && (
              <div style={{ position: 'absolute', top: '100%', right: 0, marginTop: 6, background: '#fff', borderRadius: 10, boxShadow: '0 10px 34px rgba(10,22,40,0.28)', border: '1px solid #dbe2ea', padding: 6, minWidth: 210, zIndex: 1200 }}>
                <div style={{ fontSize: 10, fontWeight: 800, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: 1, padding: '4px 10px 6px' }}>Acesso rápido</div>
                {ATALHOS_RAPIDOS.filter(a => !a.apenasVagner || isVagner).map(a => (
                  <button key={a.path} onClick={() => { setMenuRapido(false); navigate(a.path); }}
                    style={{ display: 'flex', alignItems: 'center', gap: 9, width: '100%', background: location.pathname.startsWith(a.path) ? '#f0f4ff' : 'none', border: 'none', borderRadius: 7, padding: '8px 10px', fontSize: 13.5, fontWeight: 600, color: '#0a1628', cursor: 'pointer', textAlign: 'left' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f0f4ff'}
                    onMouseLeave={e => e.currentTarget.style.background = location.pathname.startsWith(a.path) ? '#f0f4ff' : 'transparent'}>
                    <span style={{ fontSize: 15 }}>{a.icone}</span>{a.rotulo}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Tema */}
          <button onClick={() => setDarkMode(d => !d)} title={darkMode ? 'Tema claro (Alt+D)' : 'Tema escuro (Alt+D)'}
            style={{ background: 'none', border: 'none', color: '#fff', fontSize: 18, cursor: 'pointer', lineHeight: 1, padding: 4 }}>
            {darkMode ? '☀️' : '🌙'}
          </button>

          {/* Atalhos */}
          <button onClick={() => setModalAtalhos(m => !m)} title="Atalhos de teclado (?)"
            style={{ background: 'none', border: 'none', color: '#fff', fontSize: 16, cursor: 'pointer', lineHeight: 1, padding: 4 }}>
            ⌨️
          </button>

          {/* Botão calendário */}
          <button
            onClick={abrirCal}
            title="Calendário"
            style={{ background: 'none', border: 'none', color: '#fff', fontSize: 20, cursor: 'pointer', lineHeight: 1, padding: 4 }}
          >
            📅
          </button>

          {/* Botão hamburguer — visível só no mobile */}
          <button
            className="hamburger"
            onClick={() => setMenuAberto(o => !o)}
            style={{ background: 'none', border: 'none', color: '#fff', fontSize: 24, cursor: 'pointer', lineHeight: 1, padding: 4 }}
            aria-label="Menu"
          >
            {menuAberto ? '✕' : '☰'}
          </button>

          {/* Info usuário — some no mobile */}
          <div className="header-user" style={{ textAlign: 'right' }}>
            <div style={{ fontSize: 13, opacity: 0.9 }}>Olá, {nomeUsuario}</div>
            {cargoUsuario && <div style={{ fontSize: 11, opacity: 0.6 }}>{cargoUsuario}</div>}
          </div>
          {(isVagner || emailUsuario === 'pedro@preservamarcas.com.br') && (
            <Link to="/configuracoes" className="header-config" style={{ color: 'rgba(255,255,255,0.8)', fontSize: 13, textDecoration: 'none' }}>⚙️</Link>
          )}
          {nomeUsuario === 'Vagner Freitas' && (
            <button
              onClick={() => {
                const t = localStorage.getItem('token') || '';
                navigator.clipboard.writeText(t).then(() => alert('✅ Token copiado! Cole na extensão do Chrome.')).catch(() => prompt('Copie o token abaixo:', t));
              }}
              title="Copiar token para extensão Chrome"
              style={{ background: 'rgba(255,255,255,0.15)', color: '#fff', fontSize: 11, padding: '4px 8px', borderRadius: 6, border: 'none', cursor: 'pointer', fontWeight: 600 }}
            >
              🔑 Token
            </button>
          )}
          <button onClick={onLogout} style={{ background: 'rgba(255,255,255,0.2)', color: '#fff', fontSize: 12, padding: '5px 10px', borderRadius: 6, border: 'none', cursor: 'pointer' }}>
            Sair
          </button>
        </div>
      </header>

      {/* Menu mobile deslizante */}
      {menuAberto && (
        <div style={{
          position: 'fixed', inset: 0, zIndex: 190,
        }}>
          <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.4)' }} onClick={() => setMenuAberto(false)} />
          <nav style={{
            position: 'absolute', top: 56, left: 0, width: 260, bottom: 0,
            background: '#0a1628', padding: '16px 0', overflowY: 'auto',
            boxShadow: '4px 0 16px rgba(0,0,0,0.3)',
          }}>
            <div style={{ padding: '12px 20px 16px', borderBottom: '1px solid rgba(255,255,255,0.1)', marginBottom: 8 }}>
              <div style={{ color: '#fff', fontWeight: 600, fontSize: 14 }}>{nomeUsuario}</div>
              {cargoUsuario && <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 12 }}>{cargoUsuario}</div>}
            </div>
            {MENU.filter(item => {
              const ehVagner = emailUsuario === 'vagnerfreittas@gmail.com';
              if (item.apenasVagner) return ehVagner;
              // consultores: Vagner + cargos de closer (ex.: Pedro)
              if (item.consultores) return ehVagner || (cargoUsuario || '').toLowerCase().includes('closer');
              return true;
            }).map((item) => {
              if (item.grupo) {
                const aberto = gruposAbertos.includes(item.grupo);
                const ativo = item.submenu.some(s => location.pathname === s.path);
                return (
                  <div key={item.grupo}>
                    <button onClick={() => toggleGrupo(item.grupo)} style={{
                      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                      width: '100%', padding: '13px 20px', background: ativo ? 'rgba(255,255,255,0.08)' : 'none',
                      border: 'none', borderLeft: ativo ? '3px solid #fff' : '3px solid transparent',
                      color: ativo ? '#fff' : 'rgba(255,255,255,0.75)', fontSize: 15,
                      fontWeight: ativo ? 700 : 400, cursor: 'pointer', textAlign: 'left',
                    }}>
                      <span>{item.icone} {item.grupo}</span>
                      <span style={{ fontSize: 12, opacity: 0.7 }}>{aberto ? '▲' : '▼'}</span>
                    </button>
                    {aberto && item.submenu.map(({ path, label }) => (
                      <Link key={path} to={path} style={{
                        display: 'block', padding: '11px 20px 11px 36px',
                        color: location.pathname === path ? '#fff' : 'rgba(255,255,255,0.65)',
                        textDecoration: 'none', fontSize: 14,
                        fontWeight: location.pathname === path ? 700 : 400,
                        background: location.pathname === path ? 'rgba(255,255,255,0.1)' : 'none',
                        borderLeft: location.pathname === path ? '3px solid #7dd3fc' : '3px solid transparent',
                      }}>
                        {label}
                      </Link>
                    ))}
                  </div>
                );
              }
              const { path, label } = item;
              return (
                <Link key={path} to={path} style={{
                  display: 'block', padding: '13px 20px', color: location.pathname === path ? '#fff' : 'rgba(255,255,255,0.75)',
                  textDecoration: 'none', fontSize: 15, fontWeight: location.pathname === path ? 700 : 400,
                  background: location.pathname === path ? 'rgba(255,255,255,0.1)' : 'none',
                  borderLeft: location.pathname === path ? '3px solid #fff' : '3px solid transparent',
                }}>
                  {label}
                </Link>
              );
            })}
            {(isVagner || emailUsuario === 'pedro@preservamarcas.com.br') && (
              <Link to="/configuracoes" style={{ display: 'block', padding: '13px 20px', color: 'rgba(255,255,255,0.75)', textDecoration: 'none', fontSize: 15 }}>
                ⚙️ Configurações
              </Link>
            )}
          </nav>
        </div>
      )}

      <main style={{ flex: 1, padding: '20px 16px', maxWidth: 1100, margin: '0 auto', width: '100%', boxSizing: 'border-box' }}>
        <Outlet />
      </main>

      {/* Dashboard HUD — apenas Vagner */}

      {/* Modal Atalhos */}
      {modalAtalhos && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100 }}
          onClick={() => setModalAtalhos(false)}>
          <div style={{ background: '#fff', borderRadius: 8, width: 380, maxWidth: '94vw', boxShadow: '0 8px 32px rgba(0,0,0,0.2)', overflow: 'hidden' }}
            onClick={e => e.stopPropagation()}>
            <div style={{ background: '#0a1628', padding: '10px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: '#fff', fontWeight: 700, fontSize: 14 }}>⌨️ Atalhos de Teclado</span>
              <button onClick={() => setModalAtalhos(false)} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 20, cursor: 'pointer', lineHeight: 1, padding: 0 }}>×</button>
            </div>
            <div style={{ padding: '12px 16px' }}>
              {ATALHOS.map(({ tecla, acao }) => (
                <div key={tecla} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '7px 0', borderBottom: '1px solid #f3f4f6' }}>
                  <span style={{ fontSize: 13, color: '#374151' }}>{acao}</span>
                  <kbd style={{ background: '#f3f4f6', border: '1px solid #d1d5db', borderRadius: 4, padding: '2px 8px', fontSize: 12, fontFamily: 'monospace', color: '#0a1628', fontWeight: 700, whiteSpace: 'nowrap' }}>
                    {tecla}
                  </kbd>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Modal Calendário Global */}
      {modalCal && (() => {
        const { ano, mes } = mesCal;
        const nomeMes = new Date(ano, mes, 1).toLocaleString('pt-BR', { month: 'long' });
        const primeiroDia = new Date(ano, mes, 1).getDay();
        const diasNoMes = new Date(ano, mes + 1, 0).getDate();
        const hoje = new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString().slice(0, 10);

        const tarefasPorDia = {};
        tarefas.forEach(t => {
          if (!t.data_agendada) return;
          const dia = t.data_agendada.slice(0, 10);
          if (!tarefasPorDia[dia]) tarefasPorDia[dia] = [];
          tarefasPorDia[dia].push(t);
        });

        const celulas = [];
        for (let i = 0; i < primeiroDia; i++) celulas.push(null);
        for (let d = 1; d <= diasNoMes; d++) celulas.push(d);
        while (celulas.length % 7 !== 0) celulas.push(null);

        // ── Visões semana/dia: âncora + navegação por unidade ──
        const ancora = diaCal || hoje;
        const somarDias = (iso, n) => { const d = new Date(iso + 'T12:00:00'); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };
        const inicioSemana = somarDias(ancora, -new Date(ancora + 'T12:00:00').getDay());
        const diasSemana = Array.from({ length: 7 }, (_, i) => somarDias(inicioSemana, i));
        const fmtCurto = (iso) => `${iso.slice(8, 10)}/${iso.slice(5, 7)}`;
        const nomeDiaSemana = (iso) => new Date(iso + 'T12:00:00').toLocaleDateString('pt-BR', { weekday: 'long' });
        const titulo = visaoCal === 'mes' ? `${nomeMes} ${ano}`
          : visaoCal === 'semana' ? `${fmtCurto(diasSemana[0])} – ${fmtCurto(diasSemana[6])} de ${ano}`
          : `${nomeDiaSemana(ancora)}, ${fmtCurto(ancora)}/${ancora.slice(0, 4)}`;
        const navegar = (dir) => {
          if (visaoCal === 'mes') {
            setMesCal(({ ano, mes }) => { const d = new Date(ano, mes + dir, 1); return { ano: d.getFullYear(), mes: d.getMonth() }; });
          } else {
            setDiaCal(somarDias(ancora, dir * (visaoCal === 'semana' ? 7 : 1)));
          }
        };
        const ordHora = (a, b) => (a.data_agendada || '').localeCompare(b.data_agendada || '');

        // Cartão completo de tarefa (usado no dia expandido do mês e na visão Dia)
        const cartaoTarefa = (t, j) => {
          const st = statusTarefa(t);
          return (
            <div key={j} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, padding: '6px 8px', borderRadius: 4, background: st.bg, border: `1px solid ${st.cor}33`, marginBottom: 6 }}>
              <span style={{ fontSize: 10, fontWeight: 700, color: st.cor, background: '#fff', border: `1px solid ${st.cor}`, borderRadius: 3, padding: '1px 5px', whiteSpace: 'nowrap', marginTop: 1 }}>{st.label}</span>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: '#0a1628' }}>{t.urgente ? '🔴 ' : ''}{t.favorita ? '⭐ ' : ''}{t.descricao}</div>
                {t.cliente_nome && <div style={{ fontSize: 11, color: '#6b7280' }}>👤 {t.cliente_nome}</div>}
                {t.oportunidade_nome && <div style={{ fontSize: 11, color: '#6b7280' }}>📋 {t.oportunidade_nome}</div>}
                {(() => {
                  const tel = (t.cliente_id && telefonesCache[t.cliente_id]) || (t.oportunidade_id && telefonesCache[`op_${t.oportunidade_id}`]) || '';
                  return tel ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 5, marginTop: 2 }}>
                      <span style={{ fontSize: 11, color: '#6b7280' }}>📞 {tel}</span>
                      <button onClick={e => { e.stopPropagation(); copiarTelefone(tel); }} title="Copiar número"
                        style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', borderRadius: 3, padding: '1px 5px', fontSize: 10, cursor: 'pointer' }}>📋</button>
                    </div>
                  ) : null;
                })()}
                {t.destinado_a && <div style={{ fontSize: 11, color: '#6b7280' }}>Resp: {t.destinado_a}</div>}
                {fmtHora(t.data_agendada) && <div style={{ fontSize: 11, color: '#6b7280' }}>⏰ {fmtHora(t.data_agendada)}</div>}
                {t.realizado && <div style={{ fontSize: 11, color: '#16a34a', marginTop: 2 }}>✓ {t.realizado}</div>}
              </div>
              {(t.cliente_id || t.oportunidade_id) && (
                <button onClick={() => { setModalCal(false); setDiaExp(null); if (t.cliente_id) navigate(`/clientes/${t.cliente_id}/editar`); else navigate('/crm'); }}
                  style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 4, padding: '4px 10px', fontSize: 11, cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0, alignSelf: 'center' }}>
                  {t.cliente_id ? '👤 Ver cliente' : '📋 Ver CRM'}
                </button>
              )}
            </div>
          );
        };

        return (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }}
            onClick={() => { setModalCal(false); setDiaExp(null); }}>
            <div style={{ background: '#fff', borderRadius: 8, width: '100%', maxWidth: 680, maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}
              onClick={e => e.stopPropagation()}>

              {/* Header */}
              <div style={{ background: '#0a1628', padding: '10px 14px', borderRadius: '8px 8px 0 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                  <button onClick={() => navegar(-1)}
                    style={{ background: 'none', border: '1px solid rgba(255,255,255,0.3)', color: '#fff', borderRadius: 4, padding: '2px 8px', cursor: 'pointer', fontSize: 14 }}>‹</button>
                  <span style={{ color: '#fff', fontWeight: 700, fontSize: 14, textTransform: 'capitalize', minWidth: 140, textAlign: 'center' }}>{titulo}</span>
                  <button onClick={() => navegar(1)}
                    style={{ background: 'none', border: '1px solid rgba(255,255,255,0.3)', color: '#fff', borderRadius: 4, padding: '2px 8px', cursor: 'pointer', fontSize: 14 }}>›</button>
                  <div style={{ display: 'flex', borderRadius: 4, overflow: 'hidden', border: '1px solid rgba(255,255,255,0.3)', marginLeft: 4 }}>
                    {[['mes', 'Mês'], ['semana', 'Semana'], ['dia', 'Dia']].map(([v, rotulo]) => (
                      <button key={v} onClick={() => { setVisaoCal(v); if (v !== 'mes' && !diaCal) setDiaCal(hoje); }}
                        style={{ background: visaoCal === v ? 'rgba(255,255,255,0.25)' : 'none', border: 'none', color: '#fff', padding: '3px 10px', cursor: 'pointer', fontSize: 12, fontWeight: visaoCal === v ? 700 : 400 }}>{rotulo}</button>
                    ))}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                  <button onClick={() => { setModalCal(false); navigate('/agenda'); }} style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', borderRadius: 4, padding: '3px 10px', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>Ver agenda →</button>
                  <button onClick={() => { setModalCal(false); setDiaExp(null); }} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 20, cursor: 'pointer', lineHeight: 1 }}>×</button>
                </div>
              </div>

              <div style={{ padding: 14 }}>
                {visaoCal !== 'dia' && (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 2, marginBottom: 4 }}>
                  {['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'].map(d => (
                    <div key={d} style={{ textAlign: 'center', fontSize: 11, fontWeight: 700, color: '#6b7280' }}>{d}</div>
                  ))}
                </div>
                )}
                {visaoCal === 'mes' && (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 2 }}>
                  {celulas.map((dia, i) => {
                    if (!dia) return <div key={i} />;
                    const chave = `${ano}-${String(mes + 1).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
                    const itens = tarefasPorDia[chave] || [];
                    const ehHoje = chave === hoje;
                    return (
                      <div key={i} onClick={() => { if (itens.length > 0) { setDiaExp(diaExp === chave ? null : chave); itens.forEach(t => { if (t.cliente_id) buscarTelefone(t.cliente_id); if (t.oportunidade_id) buscarTelefoneOp(t.oportunidade_id); }); } }}
                        style={{ height: 72, overflow: 'hidden', border: `1px solid ${diaExp === chave ? '#0a1628' : ehHoje ? '#0a1628' : '#e5e7eb'}`, borderRadius: 4, padding: '3px 4px', background: ehHoje ? '#f0f4ff' : '#fafafa', cursor: itens.length > 0 ? 'pointer' : 'default', boxShadow: diaExp === chave ? '0 0 0 2px #0a162844' : 'none' }}>
                        <div style={{ fontSize: 11, fontWeight: ehHoje ? 700 : 400, color: ehHoje ? '#0a1628' : '#374151', marginBottom: 2, display: 'flex', justifyContent: 'space-between' }}>
                          <span>{dia}</span>
                          {itens.length > 0 && <span style={{ fontSize: 9, background: '#0a1628', color: '#fff', borderRadius: 8, padding: '0 4px' }}>{itens.length}</span>}
                        </div>
                        {itens.slice(0, 2).map((t, j) => {
                          const st = statusTarefa(t);
                          return <div key={j} style={{ fontSize: 10, background: st.bg, color: st.cor, borderRadius: 2, padding: '1px 3px', marginBottom: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t.descricao}</div>;
                        })}
                        {itens.length > 2 && <div style={{ fontSize: 9, color: '#9ca3af' }}>+{itens.length - 2} mais</div>}
                      </div>
                    );
                  })}
                </div>
                )}

                {/* ── Visão SEMANA: 7 colunas com todas as tarefas do dia ── */}
                {visaoCal === 'semana' && (
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 2 }}>
                    {diasSemana.map(chave => {
                      const itens = (tarefasPorDia[chave] || []).slice().sort(ordHora);
                      const ehHoje = chave === hoje;
                      return (
                        <div key={chave} style={{ minHeight: 220, maxHeight: 320, overflowY: 'auto', border: `1px solid ${ehHoje ? '#0a1628' : '#e5e7eb'}`, borderRadius: 4, padding: '3px 4px', background: ehHoje ? '#f0f4ff' : '#fafafa' }}>
                          <div onClick={() => { setDiaCal(chave); setVisaoCal('dia'); }} title="Abrir o dia"
                            style={{ fontSize: 11, fontWeight: ehHoje ? 700 : 600, color: '#0a1628', marginBottom: 3, display: 'flex', justifyContent: 'space-between', cursor: 'pointer' }}>
                            <span>{fmtCurto(chave)}</span>
                            {itens.length > 0 && <span style={{ fontSize: 9, background: '#0a1628', color: '#fff', borderRadius: 8, padding: '0 4px' }}>{itens.length}</span>}
                          </div>
                          {itens.map((t, j) => {
                            const st = statusTarefa(t);
                            return (
                              <div key={j} onClick={() => { setDiaCal(chave); setVisaoCal('dia'); }}
                                style={{ fontSize: 10, background: st.bg, color: st.cor, borderRadius: 2, padding: '2px 3px', marginBottom: 2, cursor: 'pointer' }}>
                                {fmtHora(t.data_agendada) && <strong>{fmtHora(t.data_agendada)} </strong>}{t.urgente ? '🔴 ' : ''}{t.favorita ? '⭐ ' : ''}{t.descricao}
                              </div>
                            );
                          })}
                          {itens.length === 0 && <div style={{ fontSize: 9, color: '#d1d5db', textAlign: 'center', paddingTop: 8 }}>—</div>}
                        </div>
                      );
                    })}
                  </div>
                )}

                {/* ── Visão DIA: lista completa do dia âncora ── */}
                {visaoCal === 'dia' && (() => {
                  const itens = (tarefasPorDia[ancora] || []).slice().sort(ordHora);
                  return itens.length === 0 ? (
                    <div style={{ textAlign: 'center', color: '#9ca3af', fontSize: 13, padding: 24 }}>Nenhuma tarefa neste dia.</div>
                  ) : (
                    <div>{itens.map(cartaoTarefa)}</div>
                  );
                })()}

                {visaoCal === 'mes' && diaExp && tarefasPorDia[diaExp] && (() => {
                  const [dAno, dMes, dDia] = diaExp.split('-');
                  const itensExp = tarefasPorDia[diaExp];
                  return (
                    <div style={{ marginTop: 10, background: '#fff', border: '1px solid #0a1628', borderRadius: 6, padding: 12 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                        <span style={{ fontSize: 13, fontWeight: 700, color: '#0a1628' }}>{dDia}/{dMes}/{dAno.slice(2)} — {itensExp.length} tarefa{itensExp.length !== 1 ? 's' : ''}</span>
                        <button onClick={() => setDiaExp(null)} style={{ background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#6b7280' }}>×</button>
                      </div>
                      {itensExp.map(cartaoTarefa)}
                    </div>
                  );
                })()}
              </div>
            </div>
          </div>
        );
      })()}

      {/* ── 👁️ Conferir tela: abre qualquer página DENTRO de um modal pra
          validar o que acabou de fazer (ex.: agendou → confere a Fila) sem
          sair da página atual. A página carrega num iframe do próprio site. */}
      {espiarRota !== null && (() => {
        const ehVagner = emailUsuario === 'vagnerfreittas@gmail.com';
        const paginas = MENU.flatMap(m => m.submenu ? m.submenu : [m]).filter(item => {
          if (item.apenasVagner) return ehVagner;
          if (item.consultores) return ehVagner || (cargoUsuario || '').toLowerCase().includes('closer');
          return true;
        });
        // Ordem alfabética pelo nome (ignorando o emoji na frente)
        const soNome = (l) => String(l).replace(/^[^\p{L}\p{N}]+/u, '').trim();
        paginas.sort((a, b) => soNome(a.label).localeCompare(soNome(b.label), 'pt-BR'));
        return (
          <div onClick={() => setEspiarRota(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1400, padding: 12 }}>
            <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 10, width: '96vw', height: '92vh', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.4)' }}>
              <div style={{ background: '#0a1628', padding: '8px 14px', display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                <span style={{ color: '#fff', fontSize: 13, fontWeight: 700, marginRight: 4 }}>👁️ Conferir tela</span>
                {paginas.map(p => (
                  <button key={p.path} onClick={() => setEspiarRota(p.path)}
                    style={{ background: espiarRota === p.path ? '#fff' : 'rgba(255,255,255,0.12)', color: espiarRota === p.path ? '#0a1628' : '#e2e8f0', border: 'none', borderRadius: 5, padding: '3px 9px', fontSize: 11.5, fontWeight: 600, cursor: 'pointer' }}>
                    {p.label}
                  </button>
                ))}
                <span style={{ flex: 1 }} />
                {espiarRota && (
                  <button onClick={() => { const r = espiarRota; setEspiarRota(null); navigate(r); }} title="Fecha o modal e vai pra página de verdade"
                    style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 5, padding: '3px 10px', fontSize: 11.5, fontWeight: 700, cursor: 'pointer' }}>↗ Abrir de verdade</button>
                )}
                <button onClick={() => setEspiarRota(null)} style={{ background: 'none', border: 'none', color: '#94a3b8', fontSize: 20, cursor: 'pointer', lineHeight: 1 }}>×</button>
              </div>
              <div style={{ flex: 1, background: '#f5f7fa' }}>
                {espiarRota ? (
                  <iframe key={espiarRota} src={espiarRota} title="Conferir tela" style={{ width: '100%', height: '100%', border: 'none', display: 'block' }} />
                ) : (
                  <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#9ca3af', fontSize: 14, textAlign: 'center', padding: 20 }}>
                    Escolha acima a tela que quer conferir — ela abre aqui dentro, sem você sair de onde está.
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })()}

      {/* ── Botão flutuante de ações rápidas (todas as páginas) ── */}
      {modalTarefaRapida && <ModalTarefaRapida onFechar={() => setModalTarefaRapida(false)} />}
      {modalNovaVenda && <ModalNovaVenda onFechar={() => setModalNovaVenda(false)} />}
      <div style={{ position: 'fixed', right: 22, bottom: 22, zIndex: 900, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 8 }}>
        {fabAberto && (
          <>
            {[
              { icone: '👁️', rotulo: 'Conferir tela', acao: () => setEspiarRota('') },
              { icone: '📝', rotulo: 'Tarefa rápida', acao: () => setModalTarefaRapida(true) },
              { icone: '💰', rotulo: 'Nova venda', acao: () => setModalNovaVenda(true) },
              { icone: '🎯', rotulo: 'Nova oportunidade', acao: () => navigate('/crm?nova=1') },
              { icone: '📅', rotulo: 'Calendário', acao: () => setModalCal(true) },
              { icone: '🔍', rotulo: 'Buscar cliente', acao: () => navigate('/clientes') },
            ].map(a => (
              <button key={a.rotulo} onClick={() => { setFabAberto(false); a.acao(); }}
                style={{ display: 'flex', alignItems: 'center', gap: 8, background: '#fff', color: '#0a1628', border: '1px solid #c8d0da', borderRadius: 999, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer', boxShadow: '0 4px 14px rgba(10,22,40,0.18)' }}>
                <span style={{ fontSize: 15 }}>{a.icone}</span>{a.rotulo}
              </button>
            ))}
          </>
        )}
        <button onClick={() => setFabAberto(v => !v)} title="Ações rápidas"
          style={{ width: 52, height: 52, borderRadius: '50%', background: '#0a1628', color: '#fff', border: 'none', fontSize: 26, fontWeight: 400, cursor: 'pointer', boxShadow: '0 6px 18px rgba(10,22,40,0.35)', lineHeight: 1, transform: fabAberto ? 'rotate(45deg)' : 'none', transition: 'transform 0.18s' }}>
          +
        </button>
      </div>
    </div>
  );
}

// ── Nova venda de qualquer página: escolhe o cliente e lança com o mesmo
// formulário da aba Venda do cadastro (mesmo POST /financeiro/parcelado —
// as parcelas caem no Contas a Receber e a venda entra nos relatórios)
function ModalNovaVenda({ onFechar }) {
  const tk = () => localStorage.getItem('token');
  const jget = (p) => fetch(p, { headers: { Authorization: `Bearer ${tk()}` } }).then(r => r.json());
  const inp = { width: '100%', padding: '4px 8px', borderRadius: 4, border: '1px solid #b0b8c4', fontSize: 13, boxSizing: 'border-box', background: '#fff', height: 30 };
  const lbl = { fontSize: 11, fontWeight: 600, color: '#6b7280', display: 'block', marginBottom: 2 };
  const mascaraMoeda = (v) => {
    const n = String(v).replace(/\D/g, '');
    if (!n) return '';
    const val = (parseInt(n, 10) / 100).toFixed(2);
    const [i, d] = val.split('.');
    return i.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + d;
  };
  const parseMoeda = (v) => parseFloat(String(v || '').replace(/\./g, '').replace(',', '.')) || 0;
  const moeda = (v) => (v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  // Cadastro antigo às vezes só tem a marca/responsável — sem o fallback a
  // venda entrava sem nome no relatório (caso MICAGI KIDS, 11/08)
  const nomeDoCliente = (c) => c?.nome || c?.razao_social || c?.responsavel || c?.processos?.[0]?.nome_marca || '';

  const [busca, setBusca] = useState('');
  const [clientes, setClientes] = useState([]);
  const [cliente, setCliente] = useState(null);
  const [catalogo, setCatalogo] = useState([]);
  const [formas, setFormas] = useState([]);
  const [itens, setItens] = useState([{ servico: '', quantidade: 1, valor: '' }]);
  const [numParcelas, setNumParcelas] = useState(1);
  const [dataPrimeira, setDataPrimeira] = useState('');
  const [forma, setForma] = useState('');
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    jget('/oportunidades/servicos-catalogo').then(d => setCatalogo((d.servicos || []).map(s => s.nome).filter(Boolean))).catch(() => {});
    // cliente_id inexistente: volta lista vazia mas traz formas de pagamento
    jget('/financeiro?tipo=receber&cliente_id=_so_formas_').then(d => setFormas(d?.formas || [])).catch(() => {});
  }, []);

  useEffect(() => {
    if (!busca.trim() || cliente) { setClientes([]); return; }
    const t = setTimeout(() => {
      jget(`/clientes?busca=${encodeURIComponent(busca)}`).then(d => setClientes(Array.isArray(d) ? d.slice(0, 8) : [])).catch(() => {});
    }, 300);
    return () => clearTimeout(t);
  }, [busca, cliente]);

  const setItem = (i, k, v) => setItens(arr => arr.map((it, j) => j === i ? { ...it, [k]: v } : it));
  const total = itens.reduce((s, it) => s + Math.max(1, parseInt(it.quantidade, 10) || 1) * parseMoeda(it.valor), 0);

  async function salvar() {
    if (!cliente) return window.alert('Escolha o cliente.');
    const validos = itens.filter(it => it.servico && parseMoeda(it.valor) > 0);
    if (!validos.length) return window.alert('Escolha o serviço e informe o valor de pelo menos um produto.');
    setSalvando(true);
    try {
      const r = await fetch('/financeiro/parcelado', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${tk()}` },
        body: JSON.stringify({
          tipo: 'receber', itens: validos,
          num_parcelas: numParcelas, data_primeira: dataPrimeira, forma_pagamento: forma,
          cliente_id: cliente._id, cliente_nome: nomeDoCliente(cliente),
        }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.erro || 'Erro ao lançar a venda');
      window.alert(`Venda lançada para ${nomeDoCliente(cliente)}! As parcelas já estão no Contas a Receber e no cadastro do cliente.`);
      onFechar();
    } catch (e) { window.alert(e.message); }
    setSalvando(false);
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }} onClick={onFechar}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 10, width: 560, maxWidth: '94%', maxHeight: '90vh', overflowY: 'auto', padding: 18, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <h2 style={{ fontSize: 15, fontWeight: 700, color: '#0a1628', margin: '0 0 10px' }}>💰 Nova venda</h2>

        <label style={lbl}>Cliente *</label>
        {cliente ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 6, padding: '6px 10px', marginBottom: 10 }}>
            <b style={{ fontSize: 13, color: '#0a1628', flex: 1 }}>{nomeDoCliente(cliente) || '(sem nome)'}</b>
            <button onClick={() => { setCliente(null); setBusca(''); }} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#b91c1c', fontWeight: 700 }}>✕</button>
          </div>
        ) : (
          <div style={{ marginBottom: 10 }}>
            <input value={busca} onChange={e => setBusca(e.target.value)} autoFocus
              placeholder="Digite o nome do cliente ou da marca…" style={inp} />
            {clientes.length > 0 && (
              <div style={{ border: '1px solid #e2e8f0', borderRadius: 6, marginTop: 4, overflow: 'hidden' }}>
                {clientes.map(c => (
                  <div key={c._id} onClick={() => { setCliente(c); setClientes([]); }}
                    style={{ padding: '6px 10px', fontSize: 13, cursor: 'pointer', borderBottom: '1px solid #f1f5f9', background: '#fff' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                    onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                    <b>{nomeDoCliente(c) || '(sem nome)'}</b>
                    {c.processos?.[0]?.nome_marca ? <span style={{ color: '#6b7280' }}> · {c.processos[0].nome_marca}</span> : null}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {itens.map((it, i) => (
          <div key={i} style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 6, alignItems: 'flex-end' }}>
            <div style={{ flex: 3, minWidth: 160 }}>
              <label style={lbl}>Serviço vendido</label>
              <select value={it.servico} onChange={e => setItem(i, 'servico', e.target.value)} style={inp}>
                <option value="">— escolha o serviço —</option>
                {catalogo.map(s => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
            <div style={{ width: 64 }}>
              <label style={lbl}>Qtd</label>
              <input type="number" min={1} value={it.quantidade} onChange={e => setItem(i, 'quantidade', Math.max(1, parseInt(e.target.value, 10) || 1))} style={inp} />
            </div>
            <div style={{ flex: 1, minWidth: 100 }}>
              <label style={lbl}>Valor unit. (R$)</label>
              <input value={it.valor} onChange={e => setItem(i, 'valor', mascaraMoeda(e.target.value))} inputMode="numeric" placeholder="0,00" style={inp} />
            </div>
            {itens.length > 1 && (
              <button onClick={() => setItens(arr => arr.filter((_, k) => k !== i))} title="Remover produto"
                style={{ background: '#fee2e2', color: '#b91c1c', border: 'none', borderRadius: 4, height: 30, padding: '0 10px', cursor: 'pointer', fontWeight: 700 }}>✕</button>
            )}
          </div>
        ))}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
          <button onClick={() => setItens(arr => [...arr, { servico: '', quantidade: 1, valor: '' }])}
            style={{ background: '#fff', color: '#0a1628', border: '1px dashed #94a3b8', borderRadius: 4, padding: '4px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
            ➕ Adicionar produto
          </button>
          {total > 0 && <span style={{ fontSize: 12.5, color: '#0a1628' }}>Total: <b>{moeda(total)}</b></span>}
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'flex-end', marginBottom: 4 }}>
          <div style={{ flex: 1, minWidth: 76 }}>
            <label style={lbl}>Parcelas</label>
            <select value={numParcelas} onChange={e => setNumParcelas(e.target.value)} style={inp}>
              {Array.from({ length: 24 }, (_, k) => k + 1).map(n => <option key={n} value={n}>{n}x</option>)}
            </select>
          </div>
          <div style={{ flex: 1, minWidth: 120 }}>
            <label style={lbl}>1º vencimento</label>
            <input type="date" value={dataPrimeira} onChange={e => setDataPrimeira(e.target.value)} style={inp} />
          </div>
          <div style={{ flex: 1, minWidth: 100 }}>
            <label style={lbl}>Forma</label>
            <select value={forma} onChange={e => setForma(e.target.value)} style={inp}>
              <option value="">—</option>
              {formas.map(x => <option key={x} value={x}>{x}</option>)}
            </select>
          </div>
        </div>
        {total > 0 && Number(numParcelas) > 1 && (
          <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 8 }}>{numParcelas}x de aprox. {moeda(total / Number(numParcelas))}</div>
        )}

        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 10 }}>
          <button onClick={onFechar} style={{ background: '#fff', color: '#374151', border: '1px solid #d1d5db', borderRadius: 6, padding: '7px 16px', fontSize: 13, cursor: 'pointer' }}>Cancelar</button>
          <button onClick={salvar} disabled={salvando || !cliente}
            style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 6, padding: '7px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer', opacity: (salvando || !cliente) ? .6 : 1 }}>
            {salvando ? 'Lançando…' : 'Lançar venda'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Tarefa rápida: cria na Agenda de qualquer página (sem vínculo) ──
function ModalTarefaRapida({ onFechar }) {
  const [descricao, setDescricao] = useState('');
  const [data, setData] = useState('');
  const [hora, setHora] = useState('');
  const [destinado, setDestinado] = useState(localStorage.getItem('nomeUsuario') || '');
  const [favorita, setFavorita] = useState(false);
  const [urgente, setUrgente] = useState(false);
  const [subagenda, setSubagenda] = useState('');
  const [salvando, setSalvando] = useState(false);
  const SUBAGENDAS_OP = [['', '📥 Geral'], ['administrativo', '🗂️ Administrativo'], ['comercial', '💼 Comercial'], ['cliente', '👥 Cliente'], ['demandas', '⚖️ Demandas Processuais'], ['pessoal', '🏠 Pessoal']];
  const inp = { width: '100%', padding: '4px 8px', borderRadius: 4, border: '1px solid #b0b8c4', fontSize: 13, boxSizing: 'border-box', background: '#fff' };
  const lbl = { fontSize: 11, fontWeight: 600, color: '#6b7280', display: 'block', marginBottom: 2 };

  async function salvar() {
    if (!descricao.trim()) return window.alert('Descreva a tarefa.');
    setSalvando(true);
    await fetch('/agenda', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
      body: JSON.stringify({ descricao: descricao.trim(), data_agendada: data ? (hora ? `${data}T${hora}` : data) : '', destinado_a: destinado, favorita, urgente, subagenda }),
    }).catch(() => {});
    setSalvando(false);
    onFechar();
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }} onClick={onFechar}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 10, width: 400, maxWidth: '94%', padding: 18, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <h2 style={{ fontSize: 15, fontWeight: 700, color: '#0a1628', margin: '0 0 10px' }}>📝 Tarefa rápida</h2>
        <label style={lbl}>Descrição *</label>
        <textarea value={descricao} onChange={e => setDescricao(e.target.value)} rows={2} autoFocus
          placeholder="O que precisa ser feito…" style={{ ...inp, resize: 'vertical', marginBottom: 8 }} />
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 90px', gap: 8, marginBottom: 8 }}>
          <div>
            <label style={lbl}>Data</label>
            <input type="date" value={data} onChange={e => setData(e.target.value)} style={inp} />
          </div>
          <div>
            <label style={lbl}>Hora</label>
            <input type="time" value={hora} onChange={e => setHora(e.target.value)} style={inp} />
          </div>
        </div>
        <label style={lbl}>Destinado a</label>
        <SelectColaborador value={destinado} onChange={setDestinado} placeholder="Selecione…" style={{ marginBottom: 10, height: 32, fontSize: 13 }} />
        <label style={lbl}>Subagenda</label>
        <select value={subagenda} onChange={e => setSubagenda(e.target.value)} style={{ ...inp, marginBottom: 10 }}>
          {SUBAGENDAS_OP.map(([v, l]) => <option key={v || 'g'} value={v}>{l}</option>)}
        </select>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <button onClick={salvar} disabled={salvando} style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 6, padding: '7px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer', opacity: salvando ? 0.6 : 1 }}>{salvando ? 'Salvando…' : 'Salvar'}</button>
          <button onClick={onFechar} style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', borderRadius: 6, padding: '7px 14px', fontSize: 13, cursor: 'pointer' }}>Cancelar</button>
          <button type="button" onClick={() => setFavorita(f => !f)} title="Favorita: aparece no filtro ⭐ da Agenda" style={{ marginLeft: 'auto', background: favorita ? '#fffbeb' : '#fff', color: favorita ? '#b45309' : '#6b7280', border: `1px solid ${favorita ? '#fde68a' : '#d1d5db'}`, borderRadius: 4, padding: '5px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{favorita ? '⭐ Favorita' : '☆ Favorita'}</button>
          <button type="button" onClick={() => setUrgente(u => !u)} title="Urgente: linha vermelha + filtro 🔴 da Agenda" style={{ background: urgente ? '#fee2e2' : '#fff', color: urgente ? '#b91c1c' : '#6b7280', border: `1px solid ${urgente ? '#fecaca' : '#d1d5db'}`, borderRadius: 4, padding: '5px 10px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{urgente ? '🔴 Urgente' : '⚪ Urgente'}</button>
        </div>
        <div style={{ fontSize: 10.5, color: '#9ca3af', marginTop: 8 }}>A tarefa cai na Agenda (sem vínculo com cliente — pra vincular, use a Agenda ou o CRM).</div>
      </div>
    </div>
  );
}
